window.initSettingAssessorDocumentsForm = function(){
	$('[name="setting_assessor_document[document_type]"]').on('change', function(){
		$('.js-type-field').addClass('is-hidden');
		$('.js-type-field').find('input').prop('disabled', true);
		if($(this).val() == 'pandadoc'){
			$('.js-pandadoc-field').removeClass('is-hidden');
			$('.js-pandadoc-field').find('input').prop('disabled', false);
		} else if($(this).val() == 'custom') {
			$('.js-custom-field').removeClass('is-hidden');
			$('.js-custom-field').find('input').prop('disabled', false);
		}
	})
	tinyMceText();
}